import { SETTINGS } from './settings';
import {
  CONNECTED_ACCOUNTS,
  CONTENT,
  EMAIL_NOTIFICATION,
  FILTER,
  MESSAGE,
  MESSAGES,
  PERSONAL_DATA,
  SECURITY,
} from './settingsCheckboxes';
import { INCOMING_REBUZZ_OPTIONS } from './incomingRebuzzOptions';
import { OUTGOING_REBUZZ_OPTIONS } from './outgoingRebuzzOptions';
import { OUTGOING_REBUZZ_PROPERTIES } from './outgoingRebuzzProperties';
import { PUBLISH_TYPES } from './publishTypes';
import { REBUZZ_OPTION_PROPERTIES } from './rebuzzOptionProperties';
import { REBUZZ_OPTIONS } from '../../../constants/rebuzzOptions';
import { DURATION_TIME_UNITS } from '../../../constants/defaultUnits';

export const initialPriceSetting = {
  id: null,
  [REBUZZ_OPTION_PROPERTIES.minPoints]: null,
  [REBUZZ_OPTION_PROPERTIES.minCurrency]: null,
  start: null,
  end: null,
};

export const initialQueueSetting = {
  id: null,
  [REBUZZ_OPTION_PROPERTIES.queueLength]: null,
  [REBUZZ_OPTION_PROPERTIES.queuePeriodicity]: null,
  start: null,
  end: null,
};

export const INITIAL_USER_SETTINGS = {
  free: {
    isSelected: false,
    optional: false,
    moderation: false,
  },
  promotion: {
    isSelected: false,
    optional: false,
    moderation: false,
  },
  endorsement: {
    isSelected: false,
    optional: false,
    moderation: false,
  },
  content: {
    isSelected: false,
    optional: false,
    moderation: false,
  },
};

export const SETTINGS_FREE_OPTION = {
  isEnabled: false,
};

export const SETTINGS_ENDORSEMENT_OPTION = {
  ...SETTINGS_FREE_OPTION,
  [REBUZZ_OPTION_PROPERTIES.priceSettings]: [
    /*
     * {
     *   minPoints: null,
     *   minCurrency: null,
     *   start: null,
     *   end: null,
     * }
     * */
  ],
  [REBUZZ_OPTION_PROPERTIES.queueSettings]: [
    /*
     * {
     *   queueLength: null,
     *   queuePeriodicity: null,
     *   start: null,
     *   end: null,
     * }
     * */
  ],
  [REBUZZ_OPTION_PROPERTIES.minPoints]: null,
  [REBUZZ_OPTION_PROPERTIES.minCurrency]: null,
  [REBUZZ_OPTION_PROPERTIES.queueLength]: null,
  [REBUZZ_OPTION_PROPERTIES.queuePeriodicity]: null,
};

export const SETTINGS_REBUZZ_OPTION = {
  ...SETTINGS_ENDORSEMENT_OPTION,
  [REBUZZ_OPTION_PROPERTIES.publish]: PUBLISH_TYPES.AUTOMATIC,
  [REBUZZ_OPTION_PROPERTIES.threadLength]: null,
};

export const SETTINGS_INCOMING_REBUZZ_OPTIONS = {
  [INCOMING_REBUZZ_OPTIONS.PAID_CONTENT]: { ...SETTINGS_REBUZZ_OPTION },
  [INCOMING_REBUZZ_OPTIONS.FREE_CONTENT]: { ...SETTINGS_FREE_OPTION },
  [INCOMING_REBUZZ_OPTIONS.PAID_PROMOTION]: { ...SETTINGS_REBUZZ_OPTION },
  [INCOMING_REBUZZ_OPTIONS.FREE_PROMOTION]: { ...SETTINGS_FREE_OPTION },
  [INCOMING_REBUZZ_OPTIONS.ENDORSEMENT]: { ...SETTINGS_ENDORSEMENT_OPTION },
};

export const SETTINGS_OUTGOING_REBUZZ_OPTION = {
  isEnabled: false,
  [OUTGOING_REBUZZ_PROPERTIES.PRICE_POINTS]: null,
  [OUTGOING_REBUZZ_PROPERTIES.PRICE_CURRENCY]: null,
};

export const SETTINGS_OUTGOING_REBUZZ_ENDORS_OPTION = {
  ...SETTINGS_OUTGOING_REBUZZ_OPTION,
  [OUTGOING_REBUZZ_PROPERTIES.BUDGET_AMOUNT]: null,
  [OUTGOING_REBUZZ_PROPERTIES.BUDGET_PERIODICITY]: null,
  [OUTGOING_REBUZZ_PROPERTIES.BALANCE]: null,
};

export const SETTINGS_OUTGOING_REBUZZ_OPTIONS = {
  [OUTGOING_REBUZZ_OPTIONS.CONTENT]: { ...SETTINGS_OUTGOING_REBUZZ_OPTION },
  [OUTGOING_REBUZZ_OPTIONS.PROMOTION]: { ...SETTINGS_OUTGOING_REBUZZ_OPTION },
  [OUTGOING_REBUZZ_OPTIONS.ENDORSEMENT]: {
    ...SETTINGS_OUTGOING_REBUZZ_ENDORS_OPTION,
  },
};

export const STORE_INITIAL_STATE = {
  [SETTINGS.PERSONAL_DATA]: {
    noteTags: ['personalData'],
    keyNoteTag: 'system',
    topicTags: ['#Topics1', '#Topics2', '#Topics3', '#Topics4'],
    suggestedTopicTags: [
      '#Restaurant',
      '#News',
      '#Hackcave',
      '#Angular',
      '#Lorem',
    ],
    locationTags: ['#Location1', '#Location2'],
    suggestedLocationTags: ['#Location3', '#Location4', '#Location5'],
    [PERSONAL_DATA.IS_NSFW]: false,
    phoneNumber: '',
    gender: '',
    dateOfBirth: '',
    selectedChannelTags: [],
    inputChannels: '',
    isEditorMaximized: false,
  },
  [SETTINGS.ACTIVITY_FEED]: {
    noteTags: ['activityFeed'],
    keyNoteTag: 'system',
    notify: {
      newBuzz: false,
      newComments: false,
      editingBuzzes: false,
      newAwards: false,
      newBoost: false,
    },
  },
  [SETTINGS.BOOST]: {
    noteTags: ['boost'],
    keyNoteTag: 'system',
    content: {
      advertisement: {
        coins: 0,
        currency: 0,
      },
      promotion: {
        coins: 0,
        currency: 0,
      },
      endorsement: {
        coins: 100,
        currency: 0,
      },
      'q&a': {
        coins: 0,
        currency: 0,
      },
    },
  },
  [SETTINGS.BUZZ]: {
    noteTags: ['privacyAndSecurity'],
    keyNoteTag: 'system',
    publicVisibility: 'everyone',
  },
  [SETTINGS.CONTENT]: {
    noteTags: ['buzzes'],
    keyNoteTag: 'system',
    [CONTENT.SAFE_BROWSING_MODE]: true,
    [CONTENT.OPEN_POSTS_IN_NEW_TAB]: false,
    [CONTENT.REDUCE_ANIMATIONS]: false,
    [CONTENT.ADULT_CONTENT]: true,
    buzzView: 'default',
    sortOrder: 'new',
  },
  [SETTINGS.EMAIL_NOTIFICATION]: {
    noteTags: ['notifications'],
    keyNoteTag: 'system',
    [EMAIL_NOTIFICATION.PLATFORM_PROMOTED]: {
      [EMAIL_NOTIFICATION.BUSINESS_TIPS]: false,
      [EMAIL_NOTIFICATION.FOMO]: true,
      [EMAIL_NOTIFICATION.PARTNER_UPDATES]: true,
      [EMAIL_NOTIFICATION.PRODUCT_TIPS]: true,
      [EMAIL_NOTIFICATION.PRODUCT_UPDATES]: true,
      [EMAIL_NOTIFICATION.RECENT_FOLLOWERS]: true,
      [EMAIL_NOTIFICATION.RECOMMENDED_CHANNELS]: true,
      [EMAIL_NOTIFICATION.SURVEY]: true,
    },
    [EMAIL_NOTIFICATION.USER_ACTIVITY]: {
      [EMAIL_NOTIFICATION.BUZZ]: true,
      [EMAIL_NOTIFICATION.DIRECT_MESSAGE]: true,
      [EMAIL_NOTIFICATION.GENERIC_NOTIFICATION]: true,
    },
  },
  [SETTINGS.FILTER]: {
    noteTags: ['notifications'],
    keyNoteTag: 'system',
    blockedChannels: [],
    mutedChannels: [],
    mutedWords: [],
    [FILTER.NOTIFICATION]: {
      [FILTER.NEW_USER]: false,
      [FILTER.NO_PROFILE_PIC]: false,
      [FILTER.NO_FOLLOW]: false,
      [FILTER.NO_FOLLOWER]: false,
      [FILTER.UNCONFIRMED_EMAIL]: true,
      [FILTER.UNCONFIRMED_PHONE]: false,
    },
  },
  [SETTINGS.MESSAGE]: {
    noteTags: ['privacyAndSecurity'],
    keyNoteTag: 'system',
    allowFrom: 'everyone',
    allowedUsers: ['Antony', 'Brasen', 'Loikon', 'Lin'],
    [MESSAGE.SHOW_READ_RECEIPT]: true,
  },
  [SETTINGS.PASSWORD]: {
    noteTags: ['password'],
    keyNoteTag: 'system',
  },
  [SETTINGS.SECURITY]: {
    noteTags: ['privacyAndSecurity'],
    keyNoteTag: 'system',
    currentRequestIds: {},
    currentLoadings: {},
    currentErrors: {},
    [SECURITY.PASSWORD_RESET_PROTECT]: false,
    [SECURITY.TWO_FACTOR_AUTH]: false,
  },
  [SETTINGS.SESSION]: {
    noteTags: ['privacyAndSecurity'],
    keyNoteTag: 'system',
    activeSessions: [],
    connectedApps: [],
    connectedSocials: [],
  },
  [SETTINGS.LEARN_MORE_ABOUT_PRIVACY_ON_GMANTRA]: {
    noteTags: ['privacyAndSecurity'],
    keyNoteTag: 'system',
  },
  [SETTINGS.CONNECTED_ACCOUNTS]: {
    noteTags: ['connectedAccounts'],
    keyNoteTag: 'system',
    [CONNECTED_ACCOUNTS.IS_CONNECTED_APPLE]: false,
    [CONNECTED_ACCOUNTS.IS_CONNECTED_GOOGLE]: false,
    [CONNECTED_ACCOUNTS.IS_CONNECTED_TWITTER]: false,
    [CONNECTED_ACCOUNTS.IS_CONNECTED_FACEBOOK]: false,
  },
  [SETTINGS.MESSAGES]: {
    noteTags: ['messages'],
    keyNoteTag: 'system',
    certainUsers: {
      [MESSAGES.USERS_FOLLOWING_CHANNEL]: false,
      [MESSAGES.USERS_I_FOLLOW]: false,
      [MESSAGES.MODERATORS]: false,
      [MESSAGES.VERIFIED_USERS]: false,
    },
  },
  [SETTINGS.INVITES]: {
    noteTags: ['invites'],
    keyNoteTag: 'system',
    certainUsers: {
      [MESSAGES.USERS_FOLLOWING_CHANNEL]: false,
      [MESSAGES.USERS_I_FOLLOW]: false,
      [MESSAGES.MODERATORS]: false,
      [MESSAGES.VERIFIED_USERS]: false,
    },
  },
  [SETTINGS.INCOMING_REBUZZ]: {
    noteTags: ['rebuzzes'],
    keyNoteTag: 'system',
    isEnabled: false,
    ...SETTINGS_INCOMING_REBUZZ_OPTIONS,
  },
  [SETTINGS.OUTGOING_REBUZZ]: {
    noteTags: ['rebuzzes'],
    keyNoteTag: 'system',
    isEnabled: false,
    [OUTGOING_REBUZZ_PROPERTIES.BUDGET_AMOUNT]: null,
    [OUTGOING_REBUZZ_PROPERTIES.BUDGET_PERIODICITY]: null,
    [OUTGOING_REBUZZ_PROPERTIES.BALANCE]: null,
    ...SETTINGS_OUTGOING_REBUZZ_OPTIONS,
  },
  [SETTINGS.REBUZZ_STATISTICS]: {
    noteTags: ['rebuzzes'],
    keyNoteTag: 'system',
    date: null,
    statistics: [
      // {
      //   id: number,
      //   userId: string,
      //   profilePicUrl: string,
      //   boostTag: string,
      //   boostAmount: number,
      //   quantity: number,
      //   sentTo: {
      //     orgId: string,
      //     streamId: string,
      //     channelId: string,
      //   },
      //   // '2023-11-21T14:51:54.023Z',
      //   rebuzzedAt: string,
      // },
    ],
    total: {
      [REBUZZ_OPTIONS.CONTENT]: {
        period: DURATION_TIME_UNITS.MONTH,
        balance: 0,
        boosts: 0,
      },
      [REBUZZ_OPTIONS.PROMOTION]: {
        period: DURATION_TIME_UNITS.MONTH,
        balance: 0,
        boosts: 0,
      },
      [REBUZZ_OPTIONS.ENDORSEMENT]: {
        period: DURATION_TIME_UNITS.MONTH,
        balance: 0,
        boosts: 0,
      },
    },
    filters: [],
  },
  [SETTINGS.REBUZZER]: {
    users: {
      byId: {},
      allId: [],
    },
  },
  [SETTINGS.PUBLISHER]: {
    noteTags: ['publisher'],
    keyNoteTag: 'system',
    canPublishToTimeline: false,
  },
  currentRequestIds: {},
  currentLoadings: {},
  currentErrors: {},
};
